<template>
    <div class="top_header" :style="isHide?'display:none':'display:flex'">
        <div class="mobile_nav">
            <p @click="nav_menu"><img src="../assets/img/nav_menu.svg" /></p>
            <div class="menuBigWrap" v-if="isShowNav">
                <div class="menuWrap">
                    <div class="home_intr">
                        <div v-for="(item,index) in menuNavList" :key="index">
                            <p :class="isShowMangeMenu?'light':''" v-if="item.Url == '/managementIndex'" @click="openMangeNav">{{item.Title}}</p>
                            <router-link v-else :to="item.Url" @click.native="closeMenu">{{item.Title}}</router-link>
                        </div>
                    </div>
                    <div class="mangeWrap" v-if="isShowMangeMenu">
                        <router-link to="/managementIndex/classHourManagement" @click.native="closeMenu">学时管理</router-link>
                        <router-link to="/managementIndex/creditManagement" @click.native="closeMenu">学分管理</router-link>
                        <router-link to="/managementIndex/courseManagement" @click.native="closeMenu">课程管理</router-link>
                    </div>
                </div>
                <p class="closeNav" @click="closeMenu"><img src="../assets/img/clear.svg" /></p>
            </div>
        </div>
        <div class="logo">
            <img src="../assets/img/logo.svg" alt="云课堂">
            <div class="home_intr">
                <router-link v-for="(item,index) in menuNavList" :key="index" :to="item.Url">{{item.Title}}</router-link>
            </div>
        </div>
        <div class="search_info">
            <router-link to="/search"><img src="../assets/img/search_icon1.svg"></router-link>
            <div class="HeadPortrait"><p @click="toParsonal">{{name}}</p></div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isShowMangeMenu: false,  // 是否打开移动端管理中心的子菜单
            isShowNav:false,  // 是否打开移动端菜单栏
            name:'',
            menuNavList:[],  // 菜单
			isHide:false,  // 隐藏头部
        }
    },
    mounted(){
		let getEx = this.getExplorer();
		if(getEx == 'ie') return;
		
        let timestamp = Date.parse(new Date())/1000;
        let data = {
            "TimeStamp":timestamp
        }
        this.getMenuNav(data);
        this.getUserName(data);
    },
    methods: {
		// 判断是否为IE内核
		getExplorer(){
			var explorer = window.navigator.userAgent,
			    compare = function (s) { return (explorer.indexOf(s) >= 0); },
			    ie11 = (function () { return ("ActiveXObject" in window) })();
			if (compare("MSIE") || ie11) { return 'ie'; }
			else if (compare("Firefox") && !ie11) { return 'Firefox'; }
			else if (compare("Chrome") && !ie11) {
			    if (explorer.indexOf("Edge") > -1) {
			        return 'Edge';
			    } else {
			       return 'Chrome';
			    }
			}
			else if (compare("Opera") && !ie11) { return 'Opera'; }
			else if (compare("Safari") && !ie11) { return 'Safari'; }
		},
        // 获取菜单导航
        getMenuNav(data){
            this.$axios.post(Const_Api_Root+'api/AdminCenter/MainMenus',data,{
                contentType: 'application/json',
                dateType:'JSON',
                xHrFields: {withCredentials:true},
                // headers: { 'Authorization': token },
				beforeSend: function (XHR) {
					XHR.withCredentials = true;  // 跨域cookie支持代码
				}
            }).then((res)=>{
                // 错误提示
                if(res.data.Status == 0){
                    this.menuNavList = res.data.Data;
                }else if(res.data.Status != -2){
					this.$message({
					    message: res.data.Data,
					    type: 'error',
					    duration: 3000
					});
				}
            }).catch((err)=>{
                throw err;
            });
        },
        // 获取用户名
        getUserName(data,token){
            this.$axios.post(Const_Api_Root+'api/Member/Info',data,{
                contentType: 'application/json',
                dateType:'JSON',
                xHrFields: {withCredentials:true},
				beforeSend: function (XHR) {
					XHR.withCredentials = true;  // 跨域cookie支持代码
				}
            }).then((res)=>{
                // 错误提示
                if(res.data.Status == 0){
                    let names = res.data.Data.Name;
                    if(names.length == 4){
                        this.name = names.substring(2);
                    }else if(names.length == 2){
                        this.name = names.substring(0);
                    }else{
                        this.name = names.substring(1);
                    }
                }else if(res.data.Status != -2){
                    this.$message({
                        message: res.data.Data,
                        type: 'error',
                        duration: 3000
                    });
                }
            }).catch((err)=>{
                throw err;
            });
        },
        // 移动端 显示菜单导航
        nav_menu(){
            this.isShowNav = true;
        },
        // 关闭导航菜单
        closeMenu(){
            this.isShowNav = false;
            this.isShowMangeMenu = false;
        },
        // 打开管理中心的子菜单
        openMangeNav(){
            this.isShowMangeMenu = true;
        },
        // 跳转到个人中心
        toParsonal(){
            this.$router.push({path: '/personalCenter'})
        }
    },
	watch:{
	    $route(to,from){
	        let wid = window.screen.width;
			
	        if(wid > 1024) return;
			
			switch(to.path){
				case '/contactUs':
					this.isHide = true;
					break;
				case '/search':
					this.isHide = true;
					break;
				case '/curriculumEvaluation':
					this.isHide = true;
					break;
				case '/managementIndex/classHourManagement':
					this.isHide = true;
					break;
				case '/managementIndex/creditManagement':
					this.isHide = true;
					break;
				case '/managementIndex/courseManagement':
					this.isHide = true;
					break;
				default:
					this.isHide = false;
			}
	    }
	}
}
</script>

<style scoped lang="less">
@media screen and (min-width: 320px) and (max-width: 1024px) {
    .home_intr{
        display: none;
    }
    .mobile_nav{
        .home_intr{
            display: block;
            margin: 60px;
            p{
                font-size: 16px;
                color: #19191A;
                font-weight: bold;
            }
            .light{
                color: #0061FE;
            }
            a{
                font-weight: bold;
            }
            div{
                margin-bottom: 40px;
                &:last-child{
                    margin-bottom: 0;
                }
            }
        }
        .menuBigWrap{
            width: 100%;
            height: 100%;
            z-index: 9;
            background: rgba(255,255,255,0.60);

            position: fixed;
            top: 0;
            left: 0;
            z-index: 9999;
            .closeNav{
                text-align: center;
                margin-top: 34px;
                img{
                    width: 26px;
                    height: 26px;
                }
            }
            a{
                display: block;
                font-size: 16px;
                color: #19191A;
            }
        }
        .menuWrap{
            background: #FFFFFF;
            box-shadow: 0 0 24px 0 rgba(0,0,0,0.12);
            border-radius: 8px;
            width: 90%;
            margin: 104px auto 0;
            font-size: 0;
            overflow: hidden;

            display: flex;
            .mangeWrap{
                margin-top: 180px;
                a{
                    margin-bottom: 40px;
                }
            }
        }
    }
    .top_header{
        height: 60px;
        justify-content: space-between;
        padding: 0 17px;
    }
}
@media screen and (min-width: 1029px) {
    .mobile_nav{
        display: none;
    }
    .top_header{
        height: 84px;
        justify-content: space-around;
        .home_intr{
            width: auto;
            text-align: center;
            margin-left: 100px;
            a{
                font-size: 14px;
                color: #19191A;
                margin: 0 30px;
            }
            // .router-link-active{
            //     color: #0061FE;
            // }
        }
    }
}
// 公共
.top_header{
    width: 100%;
    background-color: #fff;
    display: flex;
    align-items: center;
    .logo{
        display: flex;
        align-items: center;
        img{
            height: 26px;
            width: 124px;
        }
    }
    .search_info{
        display: flex;
        img{
            width: 30px;
            height: 30px;
        }
        .HeadPortrait{
            margin-left: 50px;
            // display: none;
            p{
                background: #0061FE;
                width: 30px;
                height: 30px;
                border-radius: 50%;
                font-size: 12px;
                color: #FFFFFF;
                text-align: center;
                line-height: 30px;
                cursor: pointer;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue